// components/MedicineRequest/UpdateRequestStatusModal.js
import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Label, Spinner } from "reactstrap";

const UpdateRequestStatusModal = ({ isOpen, toggle, request, onUpdate }) => {
  const [responsestatus, setResponsestatus] = useState(false);
  const [notes, setNotes] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (request) {
      setResponsestatus(request.responsestatus || false);
      setNotes(request.additional || "");
    }
  }, [request]);

  const handleSubmit = async () => {
    setLoading(true);
    setError("");

    try {
      await onUpdate({
        responsestatus: responsestatus,
        additional: notes || request.additional
      });
      toggle();
    } catch (error) {
      setError("Failed to update request");
      console.error("Failed to update request:", error);
    } finally {
      setLoading(false);
    }
  };

  if (!request) return null;

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        Update Request Status
        {/* <div className="mt-1">
          <small className="text-muted">Request #{request.id}</small>
        </div> */}
      </ModalHeader>
      <ModalBody>
        {/* <div className="mb-3">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div>
              <h6 className="mb-0">{request.medicinename}</h6>
              <small className="text-muted">by {request.manufacture}</small>
            </div>
            <div className="text-end">
              <div className="mb-1">
                <small className="text-muted">Requested by</small>
                <div>{request.name || "Anonymous"}</div>
              </div>
              {request.phonenumber && (
                <div>
                  <small className="text-muted">Phone</small>
                  <div>{request.phonenumber}</div>
                </div>
              )}
            </div>
          </div>
        </div> */}

        <FormGroup>
          <Label for="responsestatus">Response Status</Label>
          <select
            className="form-select"
            id="responsestatus"
            value={responsestatus}
            onChange={(e) => setResponsestatus(e.target.value === "true")}
          >
            <option value="false">Pending</option>
            <option value="true">Responded</option>
          </select>
        </FormGroup>

        <FormGroup>
          <Label for="notes">Additional Notes</Label>
          <textarea
            id="notes"
            className="form-control"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            rows="3"
            placeholder="Add any notes about this request..."
          />
        </FormGroup>

        {error && (
          <div className="alert alert-danger mt-3">
            <i className="fas fa-exclamation-circle me-2"></i>
            {error}
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="light" onClick={toggle} disabled={loading}>
          Cancel
        </Button>
        <Button
          color="primary"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? (
            <>
              <Spinner size="sm" className="me-2" />
              Updating...
            </>
          ) : "Update Status"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default UpdateRequestStatusModal;